import script from "./WaysToGiveView.vue?vue&type=script&setup=true&lang=js"
export * from "./WaysToGiveView.vue?vue&type=script&setup=true&lang=js"

import "./WaysToGiveView.vue?vue&type=style&index=0&id=74e32c2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e32c2c"]])

export default __exports__